export var GlobalAccessLevel;
(function (GlobalAccessLevel) {
    GlobalAccessLevel[GlobalAccessLevel["Restricted"] = 0] = "Restricted";
    GlobalAccessLevel[GlobalAccessLevel["Unlisted"] = 1] = "Unlisted";
    GlobalAccessLevel[GlobalAccessLevel["Public"] = 2] = "Public";
})(GlobalAccessLevel || (GlobalAccessLevel = {}));
